import { render, staticRenderFns } from "./setting-old.vue?vue&type=template&id=7db24905&scoped=true&"
import script from "./setting-old.vue?vue&type=script&lang=js&"
export * from "./setting-old.vue?vue&type=script&lang=js&"
import style0 from "./setting-old.vue?vue&type=style&index=0&id=7db24905&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db24905",
  null
  
)

export default component.exports